import toast from 'react-hot-toast';
import { Options } from './models/options';
// import { captureEvent } from './utils/sentryHelper';
// import * as Sentry from '@sentry/react';


const fetchWithAuth = async (url, options: Options) => {
  // Retrieve the token from localStorage
  const token = localStorage.getItem('accessToken');

  // Default headers
  const headers = {
    // 'Content-Type': 'application/json',
    ...options.headers
  };

  // Add Authorization header if token exists
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const config = {
    ...options,
    headers
  };

  try {
    const response = await fetch(url, config);
    // captureEvent({
    //   data: config.body,
    //   url,
    //   method: config.method,
    // })

    if (!response.ok) {
      // Try to get the error message from the response
      let errorMessage;
      try {
        const errorData = await response.clone().json();
        errorMessage =
          errorData.message || `HTTP error! Status: ${response.status}`;
      } catch (jsonError) {
        errorMessage = `HTTP error! Status: ${response.status}`;
      }

      // Handle unauthorized or forbidden
      if (response.status == 401 || response.status == 403) {
        localStorage.removeItem('accessToken');
        toast.error('Unauthorized access. Please log in again.');
        window.location.reload();
      }

      // For other errors, show toast and throw
      if (response.status >= 400) {
        toast.error(errorMessage);
        toast.error('An error occurred. Please try again.');
      }
      if (response.status == 404) {
        toast.error('Resource not found. Please check the URL.');
      }
      if (response.status == 500) {
        toast.error('Internal server error. Please try again later.');
      }

      return Promise.reject({data: response, message: errorMessage});
    }

    // Only show success toast for non-GET requests with successful status
    if (
      config.method !== 'GET' &&
      response.status >= 200 &&
      response.status <= 204
    ) {
      toast.success('Successful');
    }
    // Parse the response as JSON if the content type is JSON
    const body = await response.json();
    if(!body) {
      return response;
    }
    const hasBody = Object.keys(body).length;

    if (hasBody) {

      return body;
    } else {
      return response;
    }
  } catch (error) {
    console.error('Fetch error:', error);
    throw error;
  }
};

export default fetchWithAuth;
